<template>
    <div class="orderList">
        <div class="search">
            <el-input clearable
                      v-model.trim="dispatchNoList"
                      @input="processInput"
                      @clear="handleSearch"
                      placeholder="发车单号">
            </el-input>
            <selects class="search-select"
                     @clear="handleSearch"
                     :optionNum="'MAP_DISPATCH_STATUS'"
                     :mValue="dispatchStatusList"
                     :multiple="true"
                     collapse-tags
                     @getSelectValue="getSelectValue"
                     placeholder="发车单状态"
                     :prop="'dispatchStatusList'"></selects>
            <el-button type="primary"
                       @click="handleSearch">
                查询
            </el-button>
        </div>
        <!-- 发车单列表 -->
        <div class="list">
            <departure-list v-if="paginationTableData.length"
                            ref="departureList"
                            @resetData='resetData'
                            v-loading="loading"
                            v-bind="$attrs"
                            @on-click="onClick"
                            @allSelect="allSelect"
                            :appointmentSiteCodeWhiteList="appointmentSiteCodeWhiteList"
                            :totalOrderListData="totalOrderListData"
                            :orderListData='paginationTableData'></departure-list>
            <div v-else
                 class="noData">暂无数据</div>
        </div>
        <div class="
                 block">
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           class="table-pagination"
                           :current-page.sync="pageNo"
                           :page-size="pageSize"
                           layout="total, prev, pager, next"
                           :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import selects from '@/components/lots/otpSelect';

import { state } from '../store.js';
import { getDispatchList } from '../../../../api/visualMapLayout';
import departureList from './departureList';
export default {
    name: 'orderList',
    components: { selects, departureList },
    props: {
        appointmentSiteCodeWhiteList: {
            type: Array,
            default () {
                return [];
            }
        },
    },
    data () {
        return {
            searchParam: {},
            orderListData: [],
            dispatchNoList: '',
            dispatchStatusList: [],
            total: 0,
            pageNo: 1,
            pageSize: 20,
            loading: false
        };
    },
    methods: {
        processInput () {
            this.dispatchNoList = this.dispatchNoList.replace(/\s+/g, ','); // 使用正则表达式替换空格为逗号
        },
        onClick (val, index, item, totalOrderListData) {
            // 单选时全选勾选状态
            if (val && this.trueCount === this.paginationTableData.length) {
                this.$refs.departureList.checkAllTure();
            } else {
                this.$refs.departureList.checkAllFalse();
            }
            this.$emit('on-click', val, index, item, totalOrderListData);
        },
        allSelect (val, index, data, totalOrderListData) {
            this.$emit('allSelect', val, index, data, totalOrderListData);
        },
        resetData () {
            this.handleSearch();
        },
        handleSearch () {
            this.getDispatcData();
            if (this.$refs.departureList) {
                this.$refs.departureList.checkAllFalse();
            }
            this.$emit('clearMapLine');
        },
        // 获取发车单列表数据
        getDispatcData () {
            this.loading = true;
            const cpNoList = this.processString(this.dispatchNoList);
            if (cpNoList.length > 100) {
                return this.$message.warning('一次性最多输入100个客户订单号');
            }
            const parms = {
                dispatchNoList: cpNoList,
                dispatchStatusList: this.dispatchStatusList,
                siteCodeList: this.$attrs.siteList,
                pageNo: 1,
                pageSize: 10000,
                operateSystem: 'LSP' //区分系统
            };
            getDispatchList(parms).then(res => {
                this.loading = false;
                if (res && +res.code === 0) {
                    // 增加字段选中状态
                    res.data.list.forEach(item => {
                        item['checked'] = false;
                        item.planOrderFlagName = +item.planOrderFlag === 1 ? '是' : '否';
                    });
                    this.orderListData = res.data.list;
                    this.total = res.data.totalCount;
                    this.pageNo = 1;
                }
            }).catch(() => {

            });
        },
        handleSizeChange (val) {
            this.pageSize = val;
        },
        handleCurrentChange (val) {
            this.pageNo = val;
            // 切换分页全选勾选状态
            if (this.trueCount === this.paginationTableData.length) {
                this.$refs.departureList.checkAllTure();
            } else {
                this.$refs.departureList.checkAllFalse();
            }
        },
        // 获取状态
        getSelectValue (data) {
            this.dispatchStatusList = data.dispatchStatusList || [];
        },
        // 输入框校验
        processString (inputString) {
            if (inputString.includes(',')) {
                return inputString.split(',');
            } else if (!inputString) {
                return '';
            } else {
                return [inputString];
            }
        }
    },
    created () {
        this.getDispatcData();
    },
    computed: {
        pams () {
            return state.objPrams;
        },
        // 改本地分页 保持收缩展开切换 勾选状态保持
        paginationTableData () {
            const s = this.pageSize;
            const i = this.pageNo - 1;
            return this.orderListData.slice(s * i, s * (i + 1));
        },
        totalOrderListData () {
            return this.orderListData;
        },
        trueCount () {
            return this.paginationTableData.filter(item => item.checked === true).length;
        }
    },
    watch: {
        pams: function () {
            this.handleSearch();
        }
    }
};
</script>

<style lang="less" scoped>
.orderList {
    height: 80%;
    background-color: white;

    .search {
        display: flex;
        align-items: center;
        height: 30px;
        padding: 10px 10px 0 10px;

        .search-select {
            padding: 0 5px;
        }
    }

    .list {
        .noData {
            line-height: 50px;
            color: #898c8c;
            text-align: center;
            font-size: 13px;
        }
    }

    .block {
        height: 30px;
        padding-bottom: 10px;
        margin: 0 20px;

        .table-pagination {
            text-align: right;

            .btn-prev,
            .btn-next,
            .el-pager li {
                background-color: #ffffff !important;
                border: 1px solid #cccccc;
                border-radius: 4px !important;
                padding: 0;
                min-width: 30px;
                margin-right: 4px;
            }

            .el-pager li.active + li {
                border-left: 1px solid #cccccc;
            }

            .el-pager li:not(.disabled).active {
                background-color: #00bcbf !important;
                border: 1px solid #00bcbf;
                color: #ffffff;
            }
        }
    }
}
</style>